import { apiSlice } from "../../../store/slices/api/apiSlice";

export const CalendarWidgetApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCalendarWadgeAgenda: builder.mutation({
      query: ({ body, uuid, url }) => {
        return {
          url: url,
          method: "POST",
          body: body
        };
      }
    })
  })
});

export const { useGetCalendarWadgeAgendaMutation } = CalendarWidgetApi;
